<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.technologyNumber" clearable placeholder="工艺编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.technologyName" clearable placeholder="工艺名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="technologyNumber" label="工艺编码" width="140" />
      <el-table-column prop="technologyName" label="工艺名称" min-width="160" show-overflow-tooltip />
      <el-table-column prop="productNumber" label="产出产品编码" width="130" />
      <el-table-column prop="productName" label="产出产品" min-width="140" show-overflow-tooltip />
      <el-table-column label="默认" width="70" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.master === '1'" size="mini" type="success">默认</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">{{ stateLabel(row.technologyState) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="420" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.technologyId, false)">查看</el-button>
          <el-button type="text" :disabled="row.technologyState !== '01'" @click="openEdit(row.technologyId, true)">修改</el-button>
          <el-button type="text" @click="copyRow(row)">复制</el-button>
          <el-button type="text" :disabled="row.technologyState !== '01'" @click="acceptRow(row)">受理</el-button>
          <el-button type="text" :disabled="row.technologyState !== '01'" @click="rejectRow(row)">拒绝</el-button>
          <el-button type="text" :disabled="row.technologyState !== '02'" @click="unacceptRow(row)">反受理</el-button>
          <el-button type="text" :disabled="row.technologyState !== '02' || row.master === '1'" @click="setMasterRow(row)">设为默认</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.technologyState !== '01' && row.technologyState !== '03'" @click="onDelete(row.technologyId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog
      :title="form.technologyId ? (isDraft ? '修改工艺' : '查看工艺') : '新增工艺'"
      :visible.sync="visible"
      width="1280px"
      top="4vh"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" :disabled="!isDraft">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="工艺编码" prop="technologyNumber">
              <el-input v-model="form.technologyNumber" :disabled="!isDraft" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工艺名称" prop="technologyName">
              <el-input v-model="form.technologyName" :disabled="!isDraft" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产出产品" prop="productId">
              <el-input v-model="form.productName" readonly placeholder="点击选择" :disabled="!isDraft">
                <el-button slot="append" icon="el-icon-search" :disabled="!isDraft" @click="openProductSelector('output')" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工艺状态">
              <el-input :value="stateLabel(form.technologyState)" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认工艺">
              <el-switch v-model="form.master" active-value="1" inactive-value="0" :disabled="!isDraft" />
              <span style="margin-left:8px;color:#909399;font-size:12px;">同产品仅一条；生成工单优先取默认</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">工序树（可挂下级工序）</el-divider>
        <el-button v-if="isDraft" type="primary" size="mini" @click="addOperationLine(null)">添加根工序</el-button>
        <el-button v-if="isDraft" size="mini" plain @click="refreshNormsFromOps">从工序默认定额刷新</el-button>
        <el-table
          :data="operationTree"
          border
          size="small"
          style="margin-top:8px"
          row-key="operationComponentId"
          default-expand-all
          :tree-props="{ children: 'children' }"
        >
          <el-table-column label="工序" min-width="200">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.operationId"
                filterable
                placeholder="选择工序"
                style="width:100%"
                :disabled="!isDraft"
                @change="val => onOpSelected(scope.row, val)"
              >
                <el-option
                  v-for="op in operationOptions"
                  :key="op.operationId"
                  :label="op.operationName"
                  :value="op.operationId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="车间" width="140">
            <template slot-scope="scope">
              <el-select v-model="scope.row.divisionId" clearable filterable placeholder="可选" style="width:100%" :disabled="!isDraft">
                <el-option
                  v-for="d in divisionOptions"
                  :key="d.divisionId"
                  :label="d.divisionName"
                  :value="d.divisionId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="准备秒" width="90">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.tpz" :min="0" :controls="false" size="mini" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="加工秒" width="90">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.tj" :min="0" :controls="false" size="mini" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="周期产量" width="90">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.productionInOneCycle" :min="0.000001" :precision="4" :controls="false" size="mini" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="人工费率" width="90">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.laborHourlyCost" :min="0" :precision="2" :controls="false" size="mini" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="设备费率" width="90">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.machineHourlyCost" :min="0" :precision="2" :controls="false" size="mini" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="外协" width="70" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isSubcontracting" active-value="1" inactive-value="0" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column v-if="isDraft" label="操作" width="140" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="addOperationLine(scope.row)">下级</el-button>
              <el-button type="text" size="small" @click="removeOperationNode(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">产品结构（多级树；可设替代料）</el-divider>
        <el-button v-if="isDraft" type="primary" size="mini" @click="openProductSelector('structure')">添加根子件</el-button>
        <el-table
          :data="structureTree"
          border
          size="small"
          style="margin-top:8px"
          row-key="nodeId"
          default-expand-all
          :tree-props="{ children: 'children' }"
        >
          <el-table-column prop="productNumber" label="子件编码" width="120" />
          <el-table-column prop="productName" label="子件名称" min-width="140" />
          <el-table-column label="替代料" min-width="160">
            <template slot-scope="scope">
              <el-input v-model="scope.row.substituteProductName" size="mini" readonly placeholder="可选" :disabled="!isDraft">
                <el-button slot="append" icon="el-icon-search" :disabled="!isDraft" @click="openProductSelector('substitute', scope.row)" />
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.entityType" size="mini" style="width:100%" :disabled="!isDraft">
                <el-option label="原材料" value="material" />
                <el-option label="零部件" value="component" />
                <el-option label="半成品" value="intermediate" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="单位用量" width="120">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.quantity" :min="0.000001" :precision="6" :controls="false" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column v-if="isDraft" label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="openProductSelector('structureChild', scope.row)">下级</el-button>
              <el-button type="text" size="small" @click="removeStructureNode(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">工序投料（优先用于物料需求）</el-divider>
        <el-button v-if="isDraft" type="primary" size="mini" @click="addProductInLine">添加投料</el-button>
        <el-table :data="form.productInList" border size="small" style="margin-top:8px">
          <el-table-column type="index" label="#" width="50" align="center" />
          <el-table-column label="工序" min-width="180">
            <template slot-scope="scope">
              <el-select v-model="scope.row.operationComponentId" filterable placeholder="选择工序节点" style="width:100%" :disabled="!isDraft">
                <el-option
                  v-for="op in form.operationList"
                  :key="op.operationComponentId"
                  :label="opCompLabel(op)"
                  :value="op.operationComponentId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="投入产品" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" size="mini" readonly placeholder="选择产品" :disabled="!isDraft">
                <el-button slot="append" icon="el-icon-search" :disabled="!isDraft" @click="openProductSelector('productIn', scope.$index)" />
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位用量" width="120">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.quantity" :min="0.000001" :precision="6" :controls="false" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column v-if="isDraft" label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="form.productInList.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-divider content-position="left">工序产出（可选，废料可勾选）</el-divider>
        <el-button v-if="isDraft" type="primary" size="mini" @click="addProductOutLine">添加产出</el-button>
        <el-table :data="form.productOutList" border size="small" style="margin-top:8px">
          <el-table-column type="index" label="#" width="50" align="center" />
          <el-table-column label="工序" min-width="180">
            <template slot-scope="scope">
              <el-select v-model="scope.row.operationComponentId" filterable placeholder="选择工序节点" style="width:100%" :disabled="!isDraft">
                <el-option
                  v-for="op in form.operationList"
                  :key="'out-' + op.operationComponentId"
                  :label="opCompLabel(op)"
                  :value="op.operationComponentId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="产出产品" min-width="180">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productName" size="mini" readonly placeholder="选择产品" :disabled="!isDraft">
                <el-button slot="append" icon="el-icon-search" :disabled="!isDraft" @click="openProductSelector('productOut', scope.$index)" />
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="单位用量" width="120">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.quantity" :min="0.000001" :precision="6" :controls="false" style="width:100%" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column label="废料" width="70" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.waste" active-value="1" inactive-value="0" :disabled="!isDraft" />
            </template>
          </el-table-column>
          <el-table-column v-if="isDraft" label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="form.productOutList.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="isDraft" type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择产品" :visible.sync="productPickerVisible" width="720px" append-to-body :close-on-click-modal="false">
      <div class="toolbar" style="margin-bottom:8px">
        <el-input v-model="productPickerQuery" clearable placeholder="编码/名称" style="width:220px" @keyup.enter.native="loadProductPicker" />
        <el-button type="primary" icon="el-icon-search" @click="loadProductPicker">查询</el-button>
      </div>
      <el-table
        :data="productPickerList"
        border
        size="small"
        v-loading="productPickerLoading"
        max-height="360"
        @row-dblclick="onProductPicked"
        @selection-change="productPickerSelection = $event"
      >
        <el-table-column v-if="productPickerMultiple" type="selection" width="48" align="center" />
        <el-table-column prop="productNumber" label="产品编码" width="140" />
        <el-table-column prop="productName" label="产品名称" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onProductPicked(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" v-if="productPickerMultiple">
        <el-button @click="productPickerVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProductMultiple">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listTechnology, getTechnology, saveTechnology, updateTechnology, deleteTechnology,
  acceptTechnology, rejectTechnology, unacceptTechnology, copyTechnology, setMasterTechnology
} from '../../api/technology'
import { selectOperation } from '../../api/operation'
import { selectDivision } from '../../api/division'
import { listProduct } from '../../api/product'

function emptyForm() {
  return {
    technologyId: '',
    technologyNumber: '',
    technologyName: '',
    productId: '',
    productName: '',
    technologyState: '01',
    master: '0',
    active: '1',
    operationList: [],
    structureList: [],
    productInList: [],
    productOutList: []
  }
}

export default {
  name: 'MesTechnologyPage',
  components: { ListPagination },
  data() {
    return {
      query: { technologyNumber: '', technologyName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      operationOptions: [],
      divisionOptions: [],
      editable: true,
      productPickerVisible: false,
      productPickerLoading: false,
      productPickerList: [],
      productPickerQuery: '',
      productPickerMultiple: false,
      productPickerSelection: [],
      productSelectorMode: 'output',
      productInLineIndex: -1,
      productOutLineIndex: -1,
      structureParentNode: null,
      substituteTargetRow: null,
      rules: {
        technologyNumber: [{ required: true, message: '工艺编码不能为空', trigger: 'blur' }],
        technologyName: [{ required: true, message: '工艺名称不能为空', trigger: 'blur' }],
        productId: [{ required: true, message: '请选择产出产品', trigger: 'change' }]
      }
    }
  },
  computed: {
    isDraft() {
      return this.editable && this.form.technologyState === '01'
    },
    operationTree() {
      return this.buildTree(this.form.operationList || [], 'operationComponentId', 'parentId')
    },
    structureTree() {
      return this.buildTree(this.form.structureList || [], 'nodeId', 'parentId')
    }
  },
  created() {
    this.load()
  },
  methods: {
    stateLabel(s) {
      return ({ '01': '草稿', '02': '已受理', '03': '已拒绝', '04': '已过期', '05': '已检查' })[s] || s || '草稿'
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listTechnology({
        currentPage: this.page,
        pageSize: this.pageSize,
        technologyNumber: this.query.technologyNumber,
        technologyName: this.query.technologyName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id, editable) {
      this.editable = id ? editable === true : true
      const form = emptyForm()
      if (id && !this.editable) form.technologyState = '02'
      this.form = form
      this.visible = true
      this.loadOptions()
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getTechnology(id).then(res => {
        const data = res.data || {}
        this.form = Object.assign(emptyForm(), data)
        if (!this.form.master) this.form.master = '0'
        if (!this.form.operationList) this.form.operationList = []
        if (!this.form.structureList) this.form.structureList = []
        if (!this.form.productInList) this.form.productInList = []
        if (!this.form.productOutList) this.form.productOutList = []
        if (this.form.technologyState !== '01') this.editable = false
      })
    },
    loadOptions() {
      selectOperation().then(res => { this.operationOptions = res.data || [] })
      selectDivision().then(res => { this.divisionOptions = res.data || [] })
    },
    newTempId(prefix) {
      return prefix + Date.now() + '_' + Math.floor(Math.random() * 100000)
    },
    opLabel(operationId) {
      const op = this.operationOptions.find(i => i.operationId === operationId)
      return op ? op.operationName : operationId
    },
    opCompLabel(op) {
      return (this.opLabel(op.operationId) || '未选工序') + ' [' + (op.nodeNumber || '') + ']'
    },
    buildTree(flat, idKey, parentKey) {
      const map = {}
      const roots = []
      ;(flat || []).forEach(item => {
        if (!item[idKey]) this.$set(item, idKey, this.newTempId('tmp_'))
        map[item[idKey]] = item
        this.$set(item, 'children', [])
      })
      ;(flat || []).forEach(item => {
        const pid = item[parentKey]
        if (pid && map[pid]) map[pid].children.push(item)
        else roots.push(item)
      })
      return roots
    },
    openProductSelector(mode, arg) {
      if (!this.isDraft) return
      this.productSelectorMode = mode
      this.productInLineIndex = -1
      this.productOutLineIndex = -1
      this.structureParentNode = null
      this.substituteTargetRow = null
      if (mode === 'productIn') this.productInLineIndex = typeof arg === 'number' ? arg : -1
      if (mode === 'productOut') this.productOutLineIndex = typeof arg === 'number' ? arg : -1
      if (mode === 'structureChild') this.structureParentNode = arg || null
      if (mode === 'substitute') this.substituteTargetRow = arg || null
      this.productPickerMultiple = mode === 'structure' || mode === 'structureChild'
      this.productPickerSelection = []
      this.productPickerQuery = ''
      this.productPickerVisible = true
      this.loadProductPicker()
    },
    loadProductPicker() {
      this.productPickerLoading = true
      listProduct({
        currentPage: 1,
        pageSize: 50,
        productNumber: this.productPickerQuery,
        active: '1'
      }).then(res => {
        const body = res.data || {}
        this.productPickerList = body.list || []
      }).finally(() => { this.productPickerLoading = false })
    },
    onProductPicked(row) {
      if (this.productPickerMultiple) {
        this.addStructureRows([row], this.structureParentNode)
        return
      }
      this.applyProductSelect(row)
      this.productPickerVisible = false
    },
    confirmProductMultiple() {
      this.addStructureRows(this.productPickerSelection || [], this.structureParentNode)
      this.productPickerVisible = false
    },
    applyProductSelect(row) {
      if (this.productSelectorMode === 'output') {
        this.form.productId = row.productId
        this.form.productName = row.productName
      } else if (this.productSelectorMode === 'productIn') {
        const line = this.form.productInList[this.productInLineIndex]
        if (line) {
          line.productId = row.productId
          line.productNumber = row.productNumber
          line.productName = row.productName
        }
      } else if (this.productSelectorMode === 'productOut') {
        const line = this.form.productOutList[this.productOutLineIndex]
        if (line) {
          line.productId = row.productId
          line.productNumber = row.productNumber
          line.productName = row.productName
        }
      } else if (this.productSelectorMode === 'substitute') {
        if (this.substituteTargetRow) {
          this.substituteTargetRow.substituteProductId = row.productId
          this.substituteTargetRow.substituteProductNumber = row.productNumber
          this.substituteTargetRow.substituteProductName = row.productName
        }
      } else {
        this.addStructureRows([row], this.structureParentNode)
      }
    },
    addStructureRows(rows, parentNode) {
      const parentId = parentNode && parentNode.nodeId ? parentNode.nodeId : null
      const siblings = (this.form.structureList || []).filter(i => (i.parentId || null) === parentId)
      const existKeys = siblings.map(i => i.productId)
      rows.forEach(row => {
        if (!row.productId) return
        if (this.form.productId && row.productId === this.form.productId) {
          this.$message.warning('子件不能与产出产品相同：' + (row.productName || ''))
          return
        }
        if (existKeys.indexOf(row.productId) !== -1) return
        this.form.structureList.push({
          nodeId: this.newTempId('tmp_n_'),
          parentId: parentId,
          productId: row.productId,
          productNumber: row.productNumber || row.materialCode,
          productName: row.productName || row.materialName,
          substituteProductId: '',
          substituteProductName: '',
          entityType: parentId ? 'material' : 'component',
          quantity: 1
        })
        existKeys.push(row.productId)
      })
    },
    removeStructureNode(row) {
      if (!row || !row.nodeId) return
      const removeIds = new Set()
      const collect = (id) => {
        removeIds.add(id)
        ;(this.form.structureList || []).forEach(n => { if (n.parentId === id) collect(n.nodeId) })
      }
      collect(row.nodeId)
      this.form.structureList = (this.form.structureList || []).filter(n => !removeIds.has(n.nodeId))
    },
    addOperationLine(parent) {
      this.form.operationList.push({
        operationComponentId: this.newTempId('tmp_op_'),
        parentId: parent ? parent.operationComponentId : null,
        operationId: '',
        divisionId: '',
        entityType: 'operation',
        nodeNumber: String(this.form.operationList.length + 1).padStart(3, '0'),
        tpz: 0, tj: 0, productionInOneCycle: 1, laborHourlyCost: 0, machineHourlyCost: 0, isSubcontracting: '0'
      })
    },
    onOpSelected(row, operationId) {
      const op = (this.operationOptions || []).find(o => o.operationId === operationId)
      if (!op || !row) return
      if (row.tpz == null || row.tpz === 0) row.tpz = op.tpz || 0
      if (row.tj == null || row.tj === 0) row.tj = op.tj || 0
      if (!row.productionInOneCycle || row.productionInOneCycle === 1) row.productionInOneCycle = op.productionInOneCycle || 1
      if (!row.laborHourlyCost) row.laborHourlyCost = op.laborHourlyCost || 0
      if (!row.machineHourlyCost) row.machineHourlyCost = op.machineHourlyCost || 0
      row.isSubcontracting = op.isSubcontracting || '0'
    },
    refreshNormsFromOps() {
      if (!this.isDraft) return
      let n = 0
      ;(this.form.operationList || []).forEach(row => {
        if (!row.operationId) return
        const op = (this.operationOptions || []).find(o => o.operationId === row.operationId)
        if (!op) return
        row.tpz = op.tpz || 0
        row.tj = op.tj || 0
        row.productionInOneCycle = op.productionInOneCycle || 1
        row.laborHourlyCost = op.laborHourlyCost || 0
        row.machineHourlyCost = op.machineHourlyCost || 0
        n++
      })
      this.$message.success(n ? ('已刷新 ' + n + ' 道工序定额') : '无可刷新工序')
    },
    removeOperationNode(row) {
      if (!row || !row.operationComponentId) return
      const removeIds = new Set()
      const collect = (id) => {
        removeIds.add(id)
        ;(this.form.operationList || []).forEach(n => { if (n.parentId === id) collect(n.operationComponentId) })
      }
      collect(row.operationComponentId)
      this.form.operationList = (this.form.operationList || []).filter(n => !removeIds.has(n.operationComponentId))
      this.form.productInList = (this.form.productInList || []).filter(n => !removeIds.has(n.operationComponentId))
      this.form.productOutList = (this.form.productOutList || []).filter(n => !removeIds.has(n.operationComponentId))
    },
    addProductInLine() {
      this.form.productInList.push({
        operationComponentId: '', operationId: '', productId: '', productNumber: '', productName: '', quantity: 1
      })
    },
    addProductOutLine() {
      this.form.productOutList.push({
        operationComponentId: '', operationId: '', productId: '', productNumber: '', productName: '', quantity: 1, waste: '0'
      })
    },
    submit() {
      if (!this.isDraft) return
      this.$refs.form.validate(valid => {
        if (!valid) return
        for (let i = 0; i < this.form.operationList.length; i++) {
          if (!this.form.operationList[i].operationId) {
            this.$message.warning('第 ' + (i + 1) + ' 个工序节点未选择工序')
            return
          }
        }
        for (let i = 0; i < this.form.structureList.length; i++) {
          const row = this.form.structureList[i]
          if (!row.productId || !row.quantity || Number(row.quantity) <= 0) {
            this.$message.warning('产品结构第 ' + (i + 1) + ' 行数据不完整')
            return
          }
        }
        for (let i = 0; i < this.form.productInList.length; i++) {
          const row = this.form.productInList[i]
          if (!row.operationComponentId || !row.productId || !row.quantity || Number(row.quantity) <= 0) {
            this.$message.warning('工序投料第 ' + (i + 1) + ' 行请选择工序节点、产品和用量')
            return
          }
        }
        for (let i = 0; i < this.form.productOutList.length; i++) {
          const row = this.form.productOutList[i]
          if (!row.operationComponentId || !row.productId || !row.quantity || Number(row.quantity) <= 0) {
            this.$message.warning('工序产出第 ' + (i + 1) + ' 行请选择工序节点、产品和用量')
            return
          }
        }
        const payload = Object.assign({}, this.form, {
          operationList: (this.form.operationList || []).map(n => ({
            operationComponentId: n.operationComponentId,
            parentId: n.parentId || null,
            operationId: n.operationId,
            divisionId: n.divisionId,
            entityType: n.entityType || 'operation',
            priority: n.priority,
            nodeNumber: n.nodeNumber,
            tpz: n.tpz || 0,
            tj: n.tj || 0,
            productionInOneCycle: n.productionInOneCycle || 1,
            laborHourlyCost: n.laborHourlyCost || 0,
            machineHourlyCost: n.machineHourlyCost || 0,
            isSubcontracting: n.isSubcontracting || '0'
          })),
          structureList: (this.form.structureList || []).map(n => ({
            nodeId: n.nodeId,
            parentId: n.parentId || null,
            productId: n.productId,
            substituteProductId: n.substituteProductId || null,
            productNumber: n.productNumber,
            productName: n.productName,
            entityType: n.entityType,
            quantity: n.quantity,
            priority: n.priority,
            nodeNumber: n.nodeNumber
          })),
          productInList: (this.form.productInList || []).map(n => ({
            operationComponentId: n.operationComponentId,
            productId: n.productId,
            quantity: n.quantity,
            description: n.description
          })),
          productOutList: (this.form.productOutList || []).map(n => ({
            operationComponentId: n.operationComponentId,
            productId: n.productId,
            quantity: n.quantity,
            waste: n.waste || '0',
            description: n.description
          }))
        })
        this.saving = true
        const req = payload.technologyId ? updateTechnology(payload) : saveTechnology(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    acceptRow(row) {
      this.$confirm('确认受理该工艺？受理后工单可选。', '提示', { type: 'warning' }).then(() => {
        acceptTechnology(row.technologyId).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    rejectRow(row) {
      this.$confirm('确认拒绝该工艺？', '提示', { type: 'warning' }).then(() => {
        rejectTechnology(row.technologyId).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    unacceptRow(row) {
      const tip = row.master === '1'
        ? '确认反受理？工艺将回到草稿，可修改或删除。当前是默认工艺，反受理后将取消默认。'
        : '确认反受理？工艺将回到草稿，可修改或删除。'
      this.$confirm(tip, '提示', { type: 'warning' }).then(() => {
        unacceptTechnology(row.technologyId).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    setMasterRow(row) {
      this.$confirm(
        '将该工艺设为产品「' + (row.productName || row.productNumber || '') + '」的默认工艺？同产品其它默认将被取消。',
        '提示',
        { type: 'warning' }
      ).then(() => {
        setMasterTechnology(row.technologyId).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    copyRow(row) {
      this.$confirm('将复制为新的草稿工艺，是否继续？', '提示', { type: 'info' }).then(() => {
        copyTechnology(row.technologyId).then(res => {
          this.$message.success('复制成功')
          this.load()
          const newId = res.data && res.data.technologyId
          if (newId) this.openEdit(newId, true)
        })
      }).catch(() => {})
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.technologyId)
      if (!ids.length) return
      this.$confirm('确定删除所选工艺?', '提示', { type: 'warning' }).then(() => {
        deleteTechnology(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
